import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navigationLinks } from '../data/siteContent';

export default function Navbar() {
  return (
    <header className="bg-white/90 backdrop-blur border-b border-gray-200 sticky top-0 z-40 shadow-sm">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="text-2xl font-bold tracking-tight text-charcoal">
          Tax Strategy Center
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-gray-600">
          {navigationLinks.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `transition-colors duration-200 ${
                  isActive ? 'text-primary' : 'hover:text-charcoal'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/for-advisors"
            className="text-xs font-semibold uppercase tracking-wide text-gray-500 hover:text-charcoal"
          >
            Advisor Portal
          </Link>
          <Link
            to="/free-assessment"
            className="px-4 py-2 bg-primary text-white rounded-full text-sm font-semibold shadow-lg transition hover:brightness-110"
          >
            Get Assessment
          </Link>
        </div>
      </div>
    </header>
  );
}
